import { SystemOption } from '../models/system';

export const SYSTEM: Array<SystemOption> = [
  {
    id: 1,
    name: 'Wins Fix',
    icon: 'w_fix.svg'
  },
  {
    id: 2,
    name: 'Wins Fast',
    icon: 'w_fast.svg'
  },
  {
    id: 3,
    name: 'Wins Flex',
    icon: 'w_flex.svg'
  }
];
